import { useEffect, useMemo, useState } from "react";
import type { INavRecord } from "../interface.js";
import { hooks, type Weather, clientEvent } from "@/store.js";
import { useMemoizedFn } from "ahooks";
import { UseSetWeather } from "@/components/SetWeatherForm/index.jsx";
import type { Operation } from "@verdant-web/common";

function getWeather(data: Weather[]) {
	const result: Record<string, Record<string, string>> = {};

	for (const item of data) {
		if (!result[item.get("date")]) {
			result[item.get("date")] = {};
		}

		result[item.get("date")][item.get("location") || "default"] =
			item.get("temperature");
	}

	return result;
}

export default function useWeather({ planId }: { planId?: string }) {
	const data = hooks.useAllWeather({
		index: {
			where: "planId",
			equals: planId === "2" ? "" : (planId ?? -1), // NOTICE: 暂时不知道如何处理没传入planId的情况
		},
	});

	const [weather, setWeatherState] = useState<
		Record<string, Record<string, string>>
	>(() => getWeather(data));

	useEffect(() => {
		setWeatherState(getWeather(data));
	}, [data]);

	const [placeholder, setPlaceholder] = useState<React.JSX.Element | null>(
		null,
	);

	const modal = UseSetWeather();
	const setWeather = useMemoizedFn((record: INavRecord) => {
		if (!planId) return;
		modal.show({
			planId,
			date: record.date,

			onSuccess: () => {
				setWeatherState(getWeather(data));
			},
			location: record.city,
			defaultValue: record.weather,
		});
	});

	// 临时监听
	const operationChange = useMemoizedFn(
		(operation: Operation & { isLocal?: boolean }) => {
			if (!operation.isLocal) {
				// NOTICE: 自己触发也会再次触发一次
				setWeatherState(getWeather(data));
			}
		},
	);
	useEffect(() => {
		clientEvent.on("weather/onRecordChange", operationChange);
		return () => {
			clientEvent.off("weather/onRecordChange", operationChange);
		};
	}, [operationChange]);

	return { weather, setWeather, placeholder };
}
